module.exports = __webpack_public_path__ + "img/keyboard.a6bb0142.png";